<template>
    <div>
        <template slot="header">
            <h4 class="card-title">{{$t('timetables.import_logs')}}</h4>
        </template>
        <TableActionHeader @filterChange="onFilterChange" :newButton="false"></TableActionHeader>
        <b-table striped hover 
            :items="tabledata" :fields="fields" 
            :responsive="true" 
            :small="true"   
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @row-clicked="rowClicked"
            :filter="filter"
            :per-page="perPage"
            :current-page="currentPage"
            selectable 
            select-mode="single" >
            <template v-slot:cell(day)="data">
                {{ data.value.substr(0,10) }}
            </template>
        </b-table>
        <TablePagination 
                :total-rows="totalRows" 
                :per-page="perPage" 
                :currentPage="currentPage"
                @pageChange="onPageChange">
        </TablePagination>
    </div>
</template>

<script>
import importLog from '@/store/timetable/ImportLog'
import TablePagination from '@/components/Misc/TablePagination'
import TableActionHeader from '@/components/Misc/TableActionHeader'

export default {
    name: 'importLogDays',
    components: { TablePagination, TableActionHeader },
    data: function() {
        return {
            fields: [ "day" , "count" ],
            sortBy: "day",
            sortDesc: true,
            perPage: 10,
            currentPage:1,
            totalRows: 1,
            filter:""    
        }
    },
    computed: {
        tabledata() {
            return this.$store.state.importLog.importLogDays;
        }
    },
    created: function() {
       
        if (!this.$store.state.importLog) {
            this.$store.registerModule("importLog" , importLog);
        }
        this.$store.dispatch('importLog/getImportLogDaysList');
    },
    methods: {
        rowClicked: function(item) {
            this.$store.dispatch('importLog/setSelectedDay' , item.day )
        },
        onFilterChange: function(newFilter) {
            this.filter = newFilter
        },
        onPageChange(page){
            this.currentPage = page
        } 
    },
    watch: {
        tabledata: function(val) {
            if( val ) {
                this.totalRows = val.length;
                this.currentPage = 1;
            }
        }
    }
}
</script>